import { combineEpics } from 'redux-observable';
import { fetchAllAuditLogsEpic } from './fetch-all-audit-logs.epic';
import { fetchAndSetAllAuditLogsEpic } from './fetch-and-set-all-audit-logs.epic';

export const combinedAuditLogsEpics = combineEpics(fetchAllAuditLogsEpic, fetchAndSetAllAuditLogsEpic);
